module.exports = __webpack_public_path__ + "static/media/studio-slide7.3d79f05c.png";